<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Storage/MaterialIn/'+houseId">
          <el-button type="primary" size="mini">材料入库登记</el-button>
        </router-link>
        <!-- 
        <el-button type="primary" @click="EditStorageRoom('create')" size="mini">出库申请</el-button> -->
      </div>

      <label class="label-name">当前仓库：</label>
      <el-select size="small" class="organization-select" v-model="houseId" placeholder="请选择仓库">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <label style="margin-left:10px;" class="label-name">搜索：</label>
      <el-input style="display:inline-block;width:350px;" v-model="filterKey" size="small"
        placeholder="你可以搜索材料入库操作员/入库单号/发票号码/供应商"></el-input>

    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column label="入库单号" width="100px">
        <template slot-scope="scope">
          <a href="javascript:void(0)" @click="ShowMaterialInDetail(scope.row)">{{ scope.row.number }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="supplier.name" label="供应商">
      </el-table-column>
      <el-table-column prop="inVoice" label="发票号码" width="100px">
      </el-table-column>
      <el-table-column label="入库操作员" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="入库时间" width="130px">
      </el-table-column>
      <el-table-column prop="zjTotal" label="总金额(元)" width="80">
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="ShowMaterialInDetail(scope.row)" type="primary">详情</el-button>
          <el-button v-if="backRole('ST_10')" plain size="mini" @click="ShowMaterialInEdit(scope.row)" type="success">
            物资编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <material-in-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus" :materialInData="materialInData">
    </material-in-detail>

    <!-- 入库编辑 -->
    <div class="pop-room" v-if="editMaterialInStatus">
      <a href="javascript:;" @click="editMaterialInStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <!-- <el-col :span="22"> -->
        <el-form ref="form" :model="form" label-width="120px" class="form">

          <el-form-item label="供应商">
            <el-col :span="16">
              <el-select size="small" class="organization-select" v-model="form.supplierId" placeholder="请选择供应商">
                <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <router-link class="material-in-link" to="/Storage/SupplierList/1">添加供应商</router-link>
          </el-form-item>
          <el-form-item label="发票号码">
            <el-col :span="16">
              <el-input size="small" v-model="form.inVoice"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="">
            <el-button @click="editMaterialIn()" class="form-btn" type="success">确认提交</el-button>
          </el-form-item>
        </el-form>
        <!-- </el-col> -->
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  import MaterialInDetail from '@/page/storage/components/materialInDetail'
  export default {
    mixins: [Role],
    components: {
      UserInfo,
      MaterialInDetail,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        // 编辑入库单
        editMaterialInStatus: false,
        form: {
          inId: '',
          inVoice: '',
          supplierId: '',
        },
        supplierList: '',
        // 入库单明细详情
        detailStatus: false,
        materialInData: "",

        houseId: "",
        depId: "",
        houseList: "",

        organizationListData: [],
        noSelectOrganization: true,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    created() {
      if (this.$route.params.houseId) {
        this.houseId = this.$route.params.houseId / 1
      }
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      // 获取仓库列表
      this.getHouseList()

      // 获取供应商列表
      ajax.get('/supplier/list', {
        'type': 1
      }, (res) => {
        this.loading = false
        this.supplierList = res.vo.array
      })
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    methods: {
      // 编辑入库信息
      editMaterialIn() {
        ajax.post('/storage/material/in/edit', this.form, (res) => {
          this.getLists()
          this.editMaterialInStatus = false
        })
      },
      // 编辑按钮点击
      ShowMaterialInEdit(row) {
        // 编辑所有内容
        this.$router.push({
          path: '/Storage/MaterialIn',
          query: {
            inId: row.id,
            wz: 1
          }
        })

        // 单独编辑发票取消
        // this.editMaterialInStatus = true
        // this.form.inId = row.id
        // this.form.inVoice = row.inVoice
        // this.form.supplierId = row.supplier ? row.supplier.id : ''
      },
      hideDetail() {
        this.detailStatus = false
      },
      // 显示入库单详情
      ShowMaterialInDetail(row) {
        this.materialInData = row
        this.detailStatus = true
      },
      // 获取仓库列表
      getHouseList() {
        // 只能看到拥有权限的仓库
        this.houseList = this.managerStorage
        // 获取库存
        this.getLists()

        // ajax.get('/storage/house/list', {
        //   'depId': this.depId
        // }, (res) => {
        //   console.log(res.vo.array)
        //   this.houseList = res.vo.array
        //   this.houseList = util.arrConcatUnRepeat(this.houseList, this.managerStorage)

        //   console.log(this.managerStorage)

        //   // 获取库存
        //   this.getLists()
        // })
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]
            let _filterKeyLower = this.filterKey.toLowerCase()

            if (_item.creator.name.toLowerCase().indexOf(_filterKeyLower) != -1 || (_item.number
                .toLowerCase()
                .indexOf(_filterKeyLower) != -1) || (_item.inVoice && _item.inVoice.toLowerCase()
                .indexOf(_filterKeyLower) !=
                -1) || (_item.supplier && _item.supplier.name && _item.supplier.name.toLowerCase()
                .indexOf(_filterKeyLower) !=
                -1)) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        if (!this.houseId && this.houseList.length > 0) {
          this.houseId = this.houseList[0].id
        }
        if (!this.houseId) {
          return
        }

        this.loading = true
        ajax.get('/storage/material/in/list', {
          "houseId": this.houseId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })
      },
    },
    watch: {
      "houseId"() {
        this.getLists()
      },
      filterKey() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/storage/materialInList.vue